module.exports = __webpack_public_path__ + "img/perguntasFrequentesFill.aba6e8ed.svg";